export function checkBookingsToBeRemoved(bookings) {
   for (const [bookingNo, booking] of Object.entries(bookings)) {
      if (
         bookingNo !== 'bookingNo' &&
         (!booking.ignoreWhenChangingStatus || booking.ignoreWhenChangingStatus === false)
      ) {
         return true;
      }
   }
   return false;
}
